<router-outlet>
  <ngx-spinner bdOpacity=0.9 bdColor="#333" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p class="spinner-text">{{texteService.getTexte('LABEL_SPINNER')}} </p>
  </ngx-spinner>
</router-outlet>